// extracted by css-extract-rspack-plugin
export default {"root":"src-wab-client-plasmic-plasmic_kit_data_binding-PlasmicCopilotPromptImage-module__root-cg_r4D","img":"src-wab-client-plasmic-plasmic_kit_data_binding-PlasmicCopilotPromptImage-module__img-rYCI1t","closeIconContainer":"src-wab-client-plasmic-plasmic_kit_data_binding-PlasmicCopilotPromptImage-module__closeIconContainer-c3YcSf","svg":"src-wab-client-plasmic-plasmic_kit_data_binding-PlasmicCopilotPromptImage-module__svg-dWwvkZ"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-wab-client-plasmic-plasmic_kit_data_binding-PlasmicCopilotPromptImage-module__root-cg_r4D\",\"img\":\"src-wab-client-plasmic-plasmic_kit_data_binding-PlasmicCopilotPromptImage-module__img-rYCI1t\",\"closeIconContainer\":\"src-wab-client-plasmic-plasmic_kit_data_binding-PlasmicCopilotPromptImage-module__closeIconContainer-c3YcSf\",\"svg\":\"src-wab-client-plasmic-plasmic_kit_data_binding-PlasmicCopilotPromptImage-module__svg-dWwvkZ\"}";
        // 1793541995100
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  